<template>
  <el-form-item prop="positionDesktop" ref="formItem" verify :rules="variableArrRules" class="sky-server-config">
    <div class="el-icon-question wsp-padding-6 wsp-line-height-24" style="color:#38A4F5">
      岗位桌面默认配置
    </div>
    <div :class="['sky-server-config__item', 'sk-font--B']">
      <div class="arr-item">
        <div class="arr-item-title">操作系统：</div>
        <div class="arr-item-value must-input">
          <el-select
            placeholder="请选择操作系统"
            v-model="positionInfo.osTypeId"
            popper-class="sky-server-config__autocomplete"
            :class="`sky-server-config__select ${hasError && !positionInfo.osTypeId ? 'input-error' : ''}`"
            filterable
          >
            <el-option v-for="(item, index) in osList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">桌面类型：</div>
        <div class="arr-item-value  must-input">
          <el-select
            placeholder="请选择桌面类型"
            v-model="positionInfo.desktopType"
            popper-class="sky-server-config__autocomplete"
            class="sky-server-config__select"
            filterable
          >
            <el-option v-for="(item, index) in desktopTypeList" :key="index" :label="$t(item.label)" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">CPU核数：</div>
        <div class="arr-item-value must-input">
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入CPU核数大小"
            :class="`sky-server-config__select ${hasError && !positionInfo.cpuCore ? 'input-error' : ''}`"
            v-model="positionInfo.cpuCore"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">内存：</div>
        <div class="arr-item-value must-input">
          <el-input
            type="number"
            :min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入总内存大小(G)"
            :class="`sky-server-config__select`"
            v-model="positionInfo.memory"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">C盘大小：</div>
        <div class="arr-item-value must-input">
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入C盘大小"
            :class="`sky-server-config__select`"
            v-model="positionInfo.cDiskSize"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="arr-item">
        <div class="arr-item-title ">D盘大小：</div>
        <div class="arr-item-value must-input">
          <el-input
            type="number"
            min="0"
            oninput="value=value.replace(/[^0-9]/g,1)"
            placeholder="请输入D盘大小"
            :class="`sky-server-config__select`"
            v-model="positionInfo.dDiskSize"
            clearable
          ></el-input>
        </div>
      </div>
    </div>
  </el-form-item>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { OSTYPE_MNG, COMMON_MNG } from '@/api/apiModules'

export default {
  name: 'SkyPositionDesktopRelate',
  inject: ['rootView', 'elForm'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    value: {
      type: Object
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      positionInfo: null,
      loading: false,
      hasError: false,
      osList: [],
      desktopTypeList: [],
      isCb: false
    }
  },
  created() {
    if (!this.value) {
      this.positionInfo = {
        cpuCore: null,
        desktopType: null,
        cDiskSize: null,
        dDiskSize: null,
        memory: null
      }
    } else {
      this.positionInfo = this.value
    }
  },
  mounted() {
    action(OSTYPE_MNG, 'findAllActive').then(response => {
      this.osList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.osType
        }
      })
    })
    action(COMMON_MNG, 'desktopType').then(response => {
      this.desktopTypeList = response.data?.content?.itemArr.map(item => {
        return {
          id: item.label,
          label: item.label
        }
      })
    })
  },
  computed: {
    variableArrRules() {
      const validatorBranch = (rule, value, callback) => {
        this.hasError = false
        if (!this.isFill(this.positionInfo)) {
          this.hasError = true
          callback(new Error(this.$t('请输入未填项')))
        }
        if (!this.hasError) {
          callback()
        }
      }
      return [[{ validator: validatorBranch, trigger: ['blur', 'change'] }]]
    }
  },
  watch: {
    positionInfo: {
      handler: function(value) {
        this.handleFill(value)
      },
      deep: true
    },
    value: {
      handler: function(value) {
        this.positionInfo = value
      },
      deep: true
    }
  },
  methods: {
    isFill(item) {
      return item.desktopType && item.osTypeId && item.cDiskSize && item.cpuCore && item.dDiskSize && item.memory
    },
    handleFill(value) {
      this.isCb = true
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}

.el-form-item.is-error .sky-server-config__item .el-input__inner {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }

  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;

    // color: $--color-text-regular;
    &.active {
      // color: $--color-text-regular;
    }
    .arr-item {
      display: flex;
      .arr-item-title {
        padding: 0 12px;
        width: 10%;
        line-height: 32px;
      }
      .input-error {
        .el-input__inner {
          border-bottom: 1px solid #df1b1b !important;
        }
      }
    }

    .must-input:before {
      content: '*';
      color: #df1b1b;
      margin-right: 0.16667rem;
    }
  }
  & i {
    margin-right: 5px;
    color: #df1b1b;
    cursor: pointer;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
